import s from './HeaderAdvert.module.sass'

import React, { FC, memo, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { AdvertTemplate } from '@shared/ui/Layout/AdvertTemplate'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

import Script from 'next/script'
import { useAppSelector } from '@app/model/store'
import Link from 'next/link'

const SHOW_ANY_ADV = process.env.SHOW_ANY_ADV === 'true'
const IS_ENABLED_PICNIC_BANNER = false

// adv-header Billboard TopBanner
const HeaderAdvert: FC = () => {
  const router = useRouter()
  const storeCurrentPage = useAppSelector((store) => store.global.currentPage)
  const { designEnv, isMobile } = useClientResponsive()

  const [hasDefaultAdv, setHasDefaultAdv] = useState(false)
  const [isIframeLoaded, setIsIframeLoaded] = useState(false)
  const [isStaticPicnicBillboard, setIsStaticPicnicBillboard] = useState(true)

  // Лендинг ресторатора со своей шапкой
  const isOwnerPage =
    storeCurrentPage == 'owner_marketing' ||
    storeCurrentPage == 'owner_booking' ||
    storeCurrentPage === 'owner_landing_form' ||
    router.pathname == '/[city_slug]/restaurants/restorator'

  const isServiceMasterPages = storeCurrentPage === 'not_found' || storeCurrentPage === 'service_err'

  const BILLBOARD_ENABLED = false
  const isShowHeaderAdvert = BILLBOARD_ENABLED && !isOwnerPage && !isServiceMasterPages

  // основная логика для ADFox баннеров
  // отображение плоскости для верхней рекламы билборда
  const isShowAdv = SHOW_ANY_ADV && isShowHeaderAdvert && designEnv !== 'default'

  const handleEmptyAdv = () => {
    setHasDefaultAdv(false)
  }

  const handleLoadedAdv = () => {
    setHasDefaultAdv(true)
  }

  /**
   * @description если билборд не загрузился за 10 секунд,
   *    то скрываем его, чтобы меньше зависеть от iframe
   */
  useEffect(() => {
    if (isStaticPicnicBillboard) {
      const timer = setTimeout(() => {
        if (!isIframeLoaded) {
          setIsStaticPicnicBillboard(false)
        }
      }, 10000)

      return () => clearTimeout(timer)
    }
  }, [isIframeLoaded, isStaticPicnicBillboard])

  return isShowAdv ? (
    <div className={s['adv-header']} data-has-adv={isStaticPicnicBillboard || hasDefaultAdv}>
      <div className={s['adv-wrapper']}>
        {IS_ENABLED_PICNIC_BANNER && isStaticPicnicBillboard ? (
          <>
            <div
              className={`${s['adv-container']} ${s['adv-container--picnic']} ${
                isMobile ? s['adv-container--mobile'] : ''
              }`}>
              <iframe
                style={{
                  overflow: 'hidden',
                  border: '0',
                  position: 'absolute',
                  maxWidth: isMobile ? '959px' : '1676px',
                  opacity: 1,
                }}
                src={
                  isMobile
                    ? '//afisha.ru/img/top-banners/picnic/msk/mob/index.html?848514408'
                    : '//afisha.ru/img/top-banners/picnic/msk/desk/index.html?220373979'
                }
                width={isMobile ? '959' : '1676'}
                height='120'
                onLoad={() => setIsIframeLoaded(true)}
              />
            </div>
          </>
        ) : (
          <div className={`${s['adv-container']} ${isMobile ? s['adv-container--mobile'] : ''}`}>
            <AdvertTemplate
              type={'Billboard TopBanner'}
              className={`${s['adv-place']} ${isMobile ? s['adv-place--mobile'] : ''}`}
              onEmptyAdv={handleEmptyAdv}
              onLoadedAdv={handleLoadedAdv}
              singleRequest={true}
            />
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={s.plug}></div>
  )
}

export default memo(HeaderAdvert)
